import { Routes } from '@angular/router';

/**
 * Pre-initialization routes available before AppInitializationService completes.
 * These cover pages that may be navigated to during or before app init
 * (e.g., auth failures, critical errors).
 *
 * The full route tree is configured dynamically by RouteConfigService
 * after initialization, using Router.resetConfig().
 */
export const preInitRoutes: Routes = [
  {
    title: 'Service Unavailable',
    path: 'service-unavailable',
    loadComponent: () => import('./shared/components/service-unavailable/service-unavailable.component').then(c => c.ServiceUnavailableComponent)
  },
  {
    title: 'Logout',
    path: 'log-out',
    loadComponent: () => import('./features/auth/logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: 'externals',
    loadChildren: () => import('./features/externals/externals.routes').then(c => c.externalsRoutes),
  },
];